export default "__VITE_ASSET__CL5gk9m6__"